import React, {Component} from 'react';
import Table from '../../../../../components/Table';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash'
import MailerTagDetailModal from '../components/MailerTagDetailModal'
import DeleteMailerTagModal from '../components/DeleteMailerTagModal'
import MailerTagFormModal from '../components/MailerTagFormModal'


class Tags extends Component {
    static contextTypes = {api: PropTypes.object};

    constructor(props) {
        super(props);
        this.state = {};
        this.loadData = _.debounce(this.loadData, 450);
    }

    loadData = (tableState) => {
        this.tableState = tableState;
        const filters = {...tableState.filters, 'order[createdDate]': 'DESC', isActive: true};
        this.context.api.mailerTags.get(tableState.page, tableState.pageSize, undefined, filters)
    };


    openAddMailerTag = () => this.setState({addingMailerTag: true});

    closeAddMailerTag = () => {
        this.loadData(this.tableState);
        this.setState({addingMailerTag: false});
    };

    onDetailMailerTag = congress => this.setState({detailingMailerTag: congress});

    closeDetailMailerTag = () => this.setState({detailingMailerTag: false});

    onEditMailerTag = e => {
        e.stopPropagation();
        this.setState({editingMailerTag: e.currentTarget.dataset.index})
    };

    closeEditMailerTag = () => this.setState({editingMailerTag: false});

    onDeleteMailerTag = e => {
        e.stopPropagation();
        this.setState({deletingMailerTag: e.currentTarget.dataset.index})
    };

    deleteMailerTag = mailerTag => {
        this.closeDeleteMailerTag();
        this.context.api.mailerTags.delete(mailerTag.id)
    };

    closeDeleteMailerTag = () => {
        return this.setState({deletingMailerTag: false})
    };

    tableDefinition =
        [
            {
                name: 'Acciones',
                accessor: (data, index) =>
                    <span>
                        {!data.createdBySystem?
                            <div>
                        <button className='btn btn-xs btn-primary' data-index={index} onClick={this.onEditMailerTag}><i
                            className='ti-pencil'/></button>
                        &nbsp;
                        <button className='btn btn-xs btn-danger' data-index={index} onClick={this.onDeleteMailerTag}><i
                            className='ti-trash'/></button>
                            </div>:null}
                    </span>
            }, {
            name: 'Grupo',
            id: 'name',
            filterable: true,
            accessor: 'name',
        }
        ];

    render() {
        return (
            <div className="container-fluid Directory">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Grupos de correo</h4>
                            </div>
                            <div className="card-content">
                                <div className='buttonContainer'>
                                </div>
                                <div className='buttonContainer'>
                                    <button className='btn btn-success btn-fill btn-magnify pull-right'
                                            onClick={this.openAddMailerTag}>
                                        <span className='btn-label'><i className='ti-plus'/></span>
                                    </button>
                                    <div className='clearfix'/>
                                </div>
                                <br/>
                                <Table
                                    paginated
                                    defaultPageSize={50}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.mailerTagsMeta.totalItems}
                                    loadData={this.loadData}
                                    columns={this.tableDefinition}
                                    data={this.props.mailerTags}
                                    trProps={(mailerTag) => ({onClick: () => this.onDetailMailerTag(mailerTag)})}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*Adding a new Tag*/}
                {this.state.addingMailerTag &&
                <MailerTagFormModal
                    onHide={this.closeAddMailerTag}/>}
                {/*  Edit tag Modal */}
                {this.state.editingMailerTag &&
                <MailerTagFormModal
                    onHide={this.closeEditMailerTag}
                    editing={this.props.mailerTags[this.state.editingMailerTag]}/>}
                {/* Delete tag Modal*/}
                {this.state.deletingMailerTag &&
                <DeleteMailerTagModal
                    mailerTag={this.props.mailerTags[this.state.deletingMailerTag]}
                    onHide={this.closeDeleteMailerTag}
                    onConfirm={this.deleteMailerTag}/>}
                {/* Show tag detail Modal*/}
                {this.state.detailingMailerTag &&
                <MailerTagDetailModal
                    mailerTag={this.state.detailingMailerTag}
                    onHide={this.closeDetailMailerTag}/>}
            </div>
        );
    }
}

const mapStateToProps = ({api: {mailerTags = [], mailerTagsMeta = {}}}) => {
    return {mailerTags, mailerTagsMeta}
};

export default connect(mapStateToProps)(Tags);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/Tags/index.jsx